import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import TextInput from '../../../TextInput';
import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import { DIALOG_TITLE } from '../../../../constants/strings';
import { MobilePhone } from '../../../MobilePhone';
import styles from '../../styles.styl';

const { EMAIL, PHONE_NUMBER } = PROFILE_FIELDS_TYPES;

const GeneralInfoContactForm = ({
  email,
  phoneNumber,
  formatMessage,
  onChange,
  validateErrors,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);

  const handlePhoneChange = phone => {
    onChange({ [PHONE_NUMBER]: phone });
  };

  const emailError = validateErrors[EMAIL] && {
    [EMAIL]: formatMessage({ id: 'error.alreadyTakenEmail' }),
  };
  const phoneNumberError = validateErrors[PHONE_NUMBER] && {
    [PHONE_NUMBER]: formatMessage({ id: 'error.invalidPhoneNumber' }),
  };

  return (
    <Fragment>
      {/*     EMAIL     */}
      <TextInput
        {...makeProfileField(EMAIL, FIELD_FILLING_TYPES.OPTIONAL)}
        value={email}
      />
      <FormErrorBlock type={EMAIL} errors={emailError} />
      <div className="mt3" styleName="and-or">
        {formatMessage(DIALOG_TITLE.andOr)}
      </div>
      {/*     PHONE NUMBER     */}
      <MobilePhone
        {...makeProfileField(PHONE_NUMBER, FIELD_FILLING_TYPES.OPTIONAL)}
        value={phoneNumber}
        formatMessage={formatMessage}
        onChange={handlePhoneChange}
      />
      <FormErrorBlock type={PHONE_NUMBER} errors={phoneNumberError} />
    </Fragment>
  );
};

GeneralInfoContactForm.propTypes = {
  formatMessage: PropTypes.func,
  email: PropTypes.string,
  phoneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  validateErrors: PropTypes.object,
};

export default CSSModules(GeneralInfoContactForm, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentGeneralInfo/GeneralInfoContactForm/index.jsx